import React from "react";
import ButtonStyles from "../../../button/Button.styles";
import { IPhaseListProps } from "./PhaseList.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import PHASE_LIST_ITEM from "./PhaseList.renderer";
import { Stack } from "react-bootstrap";
import {
  DetailsList,
  DetailsListHeader,
} from "../../../../shared/styles/Card.styles";
import { PackageDetailsPhase } from "../../../../api/models";
import { isMobile } from "react-device-detect";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";

const renderPhases = (phases: Array<PackageDetailsPhase>): React.ReactNode => {
  return phases.map((phaseSummary) => {
    return (
      <PHASE_LIST_ITEM
        phaseSummary={phaseSummary}
        key={phaseSummary.phase?.name}
      />
    );
  });
};

const PHASE_LIST: React.FC<IPhaseListProps> = (props: IPhaseListProps) => {
  const sendDataToGTM = useGTMDispatch();
  const { phases } = props;
  return (
    <DetailsList className="details-list" data-testid="phase-detail-list">
      <DetailsListHeader
        className="details-list-header"
        direction={
          /* istanbul ignore next*/ isMobile ? "vertical" : "horizontal"
        }
        data-testid="phase-list-header"
      >
        <h4>Phase</h4>
        <span
          className={
            /* istanbul ignore next*/ !isMobile ? "ms-auto" : undefined
          }
        >
          <ButtonStyles.LinkButton
            className="link-button"
            data-testid="phase-list-button"
          >
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.consumersenergy.com/residential/programs-and-services/-/media/E41D4F727EC8415AAD04187385FFDE09.ashx"
              onClick={
                /* istanbul ignore next*/ () => {
                  sendDataToGTM({
                    event: "eventTracking",
                    category: "Construction",
                    action: "Click - Project Details",
                    label: "What Do These Mean",
                  });
                }
              }
            >
              What do these mean?{" "}
            </a>
            <FontAwesomeIcon
              icon={faExternalLinkAlt}
              data-testid="phase-list-icon"
            />
          </ButtonStyles.LinkButton>
        </span>
      </DetailsListHeader>
      <Stack data-testid="phase-list-phases">
        {phases && phases.length && renderPhases(phases)}
      </Stack>
    </DetailsList>
  );
};
export default PHASE_LIST;
